
// Copyright (c) 2024 ParkEngage Inc. All rights reserved.

// This software is the confidential and proprietary information of
// ParkEngage Inc. ("Confidential Information"). You shall not
// disclose such Confidential Information and shall use it only in
// accordance with the terms of the license agreement you entered into
// with ParkEngage Inc.

// This source code is a valuable trade secret of ParkEngage Inc.

// THIS SOFTWARE IS PROVIDED BY ParkEngage Inc. ``AS IS'' AND ANY
// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
// PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL [YOUR COMPANY NAME] OR
// CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
// PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

// The views and conclusions contained in the software and documentation
// are those of the authors and should not be interpreted as representing
// official policies, either expressed or implied, of ParkEngage Inc.

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import Picker from 'react-mobile-picker'
import { dayData, EMPTY_ARRAY, EMPTY_OBJECT, hoursData, minutesData } from '../constants/globalConstants'
import { Row } from 'react-bootstrap'
import CONSTANTS from '../redux/constants'
import moment from 'moment-timezone'
import { Circles } from 'react-loader-spinner'
import debounce from 'lodash/debounce'
import { getConvertedDate, getHoursIndayFormat, isMaxDays, isPermissionExist, loggedInUserData, sortPortalPermissionByKey } from '../utils/helper'
require('./ReactMobiltySpinner.scss')

class ReactMobiltySpinner extends Component {
    cliclRateBand
    cliclEvent
    constructor(props) {
        super(props)

        this.state = {
            dayValueGroups: { day: 0 },
            dayOptionGroups: { day: dayData },
            hourValueGroups: { hour: 0 },
            hourOptionGroups: { hour: hoursData },
            minuteValueGroups: { minute: 0 },
            minuteOptionGroups: { minute: minutesData },
            rateBandsValues: { rateBands: 0 },
            eventsIndex: null,
            bandIndex: 0,
            dateLoad: false,
            is_rate_display_with_events: false,
            // durationSelector: 1,
        }
        this.cliclRateBand = debounce(this.cliclRateBandDeb.bind(this), 200, { leading: false, trailing: true })
        this.cliclEvent = debounce(this.cliclEventDeb.bind(this), 200, { leading: false, trailing: true })
    }

    componentDidMount() {
        const {
            rateBands,
            events,
            pageOnLoad,
            isRateBand
        } = this.props

        const rate_display_with_events = (events?.length > 0) ? events.some(item => item?.display_rate_with_event === '1') : false

        // to check the condition whether rate display with events or not
        this.checkToRenderEventsAndBandTogether(events)
        if (pageOnLoad) {
            if (rate_display_with_events) {
                if (events?.length == 1 && rateBands?.rateBands?.length == 0 && isRateBand) {
                    this.cliclEvent(events[0], 0)
                }
            } else {
                if (events?.length > 0) {
                    if (events?.length === 1) {
                        this.cliclEvent(events[0], 0)
                    }
                } else {
                    if (rateBands?.rateBands?.length == 1 && isRateBand) {
                        this.cliclRateBand(this.state.rateBandsValues, rateBands, 0)
                    }
                }
            }
        }
    }


    componentDidUpdate(prevProps) {
        const {
            rateBands,
            events,
            // pageOnLoad,
            priceBandLoad,
            isRateBand,
            isRateBandSelected,
            currentSelVehicle,
            facilityData,
            totalHoursLength,
            durationSelector,
            hotel_type,
            resetBand
        } = this.props
        if (prevProps.events != events || prevProps.rateBands != rateBands) {
            if (this.state.is_rate_display_with_events) {
                if (events?.length === 1 && !isRateBandSelected && rateBands?.rateBands?.length == 0) {
                    this.cliclEvent(events[0], 0)
                }
            } else {
                if (priceBandLoad) {
                    if (events?.length > 0) {
                        if (events?.length === 1 && !isRateBandSelected) {
                            this.cliclEvent(events[0], 0)
                        }
                    } else {
                        if (rateBands?.rateBands?.length == 1 && isRateBand) {
                            this.cliclRateBand(this.state.rateBandsValues, rateBands, 0)
                        }
                    }
                } else if (events?.length === 1 && !isRateBandSelected) {
                    this.cliclEvent(events[0], 0)
                } else if (rateBands?.rateBands?.length == 1 && isRateBand && !isRateBandSelected) {
                    this.cliclRateBand(this.state.rateBandsValues, rateBands, 0)
                }
                if(resetBand != prevProps?.resetBand) {
                    this.resetBand(true)
                }
            }
            // to check the condition whether rate display with events or not
            this.checkToRenderEventsAndBandTogether(events)
        }
        if ((facilityData?.facility?.facility_configuration?.is_overnight_hourly_enabled == '1' || facilityData?.facility_configuration?.is_overnight_hourly_enabled == '1') && currentSelVehicle && (prevProps.currentSelVehicle != currentSelVehicle)) {
            this.setState({ hourValueGroups: { hour: 0 }, minuteValueGroups: { minute: 0 }, dayValueGroups: { day: 0 } })
        }
        if (totalHoursLength != prevProps.totalHoursLength) {
            if (durationSelector == '1' && hotel_type == '1' && Number(totalHoursLength) > 0) {
                this.props.setselctedDateTime({ ...this.props.selctedDateTime, daysHrs: this.getHoursIndate(totalHoursLength), active: true, bandActive: true })
            }
        }
    }

    // to check the condition whether rate display with events or not
    checkToRenderEventsAndBandTogether = (eventsData) => {
        if (eventsData?.length == 0 || !eventsData) {
            return false
        }

        const rate_display_with_events = eventsData.some(item => item?.display_rate_with_event === '1')
        this.setState({ is_rate_display_with_events: rate_display_with_events })
    }

    getHoursIndate = (hours) => {
        let dt = getHoursIndayFormat(hours, false)
        return `${Number(dt?.day) > 1 ? dt.day + ' Days ' : Number(dt?.day) == 1 ? dt.day + ' Day ' : ''}
            ${Number(dt?.hour) > 1 ? dt.hour + ' Hours' : Number(dt?.hour) == 1 ? dt.hour + ' Hour' : ''}
            ${Number(dt?.minute) > 1 ? dt.minute + ' Minutes' : Number(dt?.minute) == 1 ? dt.minute + ' Minute' : ''}`
    }
    handleChange = (name, value) => {
        const { handleTimeLength, facilityData, ticketDetails, dataOnLoad, page } = this.props
        const e = { target: { 'name': [name], 'value': [value] } }
        const getDays = this.getDurationInDays(name, value)
        if (name === 'day') {
            const maxDayFeature =  isMaxDays(facilityData?.facility, page === 'extend' ? dataOnLoad : ticketDetails, true, getDays, false, '', '')
            if(maxDayFeature) {
                this.setState(({ dayValueGroups }) => ({ dayValueGroups: { ...dayValueGroups, [name]: value } }))
                handleTimeLength(e, 'day')
            }
        } else if (name === 'hour') {
            const maxDayFeature =  isMaxDays(facilityData?.facility, page === 'extend' ? dataOnLoad : ticketDetails, true, getDays, false, '', '')
            if(maxDayFeature) {
                this.setState(({ hourValueGroups }) => ({ hourValueGroups: { ...hourValueGroups, [name]: value } }))
                handleTimeLength(e, 'hour')
            }
        } else if (name === 'minute') {
            const maxDayFeature =  isMaxDays(facilityData?.facility, page === 'extend' ? dataOnLoad : ticketDetails, true, getDays, false, '', '')
            if(maxDayFeature) {
                this.setState(({ minuteValueGroups }) => ({ minuteValueGroups: { ...minuteValueGroups, [name]: value } }))
                handleTimeLength(e, 'minute')
            }
        } else if (name === 'rateBands') {
            this.setState(({ rateBandsValues }) => ({ rateBandsValues: { ...rateBandsValues, [name]: value } }))
            handleTimeLength(e, 'rateBands')
        } else if (name === 'events') {
            this.setState(({ rateBandsValues }) => ({ rateBandsValues: { ...rateBandsValues, [name]: value } }))
            handleTimeLength({ target: { 'name': name, 'value': value } }, 'events')
        }
    }

    getDurationInDays = (name = '', value = 0) => {
        const days = Number(this.state.dayValueGroups.day)
        const hours = Number(this.state.hourValueGroups?.hour) / 24
        const mins = Number(this.state.minuteValueGroups?.minute) / 1440
        let ans = 0
        if(name === 'day') {
            ans = Number(value) + hours + mins
        } else if (name === 'hour') {
            ans = days + Number(Number(value) / 24) + mins
        } else if (name === 'minute') {
            ans = days + hours + (Number(value) / 1440)
        }
        return ans
    }

    cliclRateBandDeb = (e, band = [], ind, bandind = null) => {
        const { activeRateBand, setIndexForCalc, indexForCalc, setCustomeLoaderForRateBand, setIsRateOrEventShow, oversizeLoader, disableRates, rateBandData, facilityData, ticketDetails } = this.props
        if(!oversizeLoader && !disableRates) {
            if (ind === bandind) {
                this.resetBand()
            } else if (activeRateBand) {
                let rateBandSelected = rateBandData?.filter((item) => item?.rate_band_description == band?.rateBands[ind])
                const getDay = rateBandSelected?.[0]?.id ? (Number(rateBandSelected?.[0]?.max_stay) / 24) : 0
                const maxDayFeature =  isMaxDays(facilityData?.facility, ticketDetails, true, getDay, false, '', '')
                if(maxDayFeature) {
                    this.props.dispatch({ type: CONSTANTS.PROMO_MSGE_ENABLE })
                    // this.setState({bandIndex: ind+1})
                    setIndexForCalc({
                        ...indexForCalc,
                        bandIndex: ind + 1
                    })
                    setCustomeLoaderForRateBand(true)
                    this.handleChange(Object.keys(e)[0], band?.rateBands[ind])
                    this.props.setIsRateBandSelected(true)
                    this.props.setselctedDateTime({ ...this.props.selctedDateTime, bandActive: false, price: 0 })
                }
            }
            setIsRateOrEventShow(2)
        }
    }

    resetBand = (toReset = false) => {
        const { facilityData, setFacilityData, setIndexForCalc, indexForCalc, setSeletedRateBand, setTotalHoursLength, page, setTimeDuration, setRateBandId, priceBreakAPI, setIsRateChangedWithPromo, setIsPriceZero,
            setResetPromo, setselctedDateTime, selctedDateTime,
            curRateBandRef } = this.props
        if(toReset) {
            setResetPromo(true)
        }
        if(curRateBandRef) {
            curRateBandRef.current = null
        }
        // this.setState({bandIndex: 0})
        setIndexForCalc({
            ...indexForCalc,
            bandIndex: 0
        })
        localStorage.removeItem('seletedRateBand')
        setIsRateChangedWithPromo(false)
        setSeletedRateBand('')
        setTotalHoursLength('0.00')
        this.props.setIsRateBandSelected(false)
        if (page === 'extend') {
            priceBreakAPI(false)
            setTimeDuration({ days: '0', hours: '0', minutes: '0' })
            setRateBandId(null)
        } else {
            const faciData = JSON.parse(JSON.stringify(facilityData))
            let curFacTime = new Date(getConvertedDate(moment(new Date()).tz(faciData?.facility?.timezone ? faciData?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD HH:mm:ss')))
            faciData.valid_till = curFacTime
            faciData.parking_amount = '0.00'
            faciData.processing_fee = '0.00'
            faciData.tax_rate = '0.00'
            faciData.paid_amount = '0.00'
            faciData.payable_amount = '0.00'
            faciData.is_price_applicable = '0'
            faciData.discount_amount = '0'
            faciData.discount_hours = '0'
            faciData.display_msg = ''
            if (facilityData?.facility?.facility_configuration?.is_overnight_hourly_enabled == '1' || facilityData?.facility_configuration?.is_overnight_hourly_enabled == '1') {
                faciData.surcharge_fee = '0.00'
            }
            setFacilityData(faciData)
            setIsPriceZero(true)
            setselctedDateTime({ ...selctedDateTime, active: false, bandActive: false, price: 0, daysHrs: null })
        }
    }

    cliclEventDeb = (data, i) => {
        const { setIndexForCalc, indexForCalc, facilityData, setFacilityData, isRateBandSelected, setTotalHoursLength, setEventMessage, setIsRateOrEventShow, oversizeLoader, disableRates } = this.props
        // const { eventsIndex } = this.state
        if(!oversizeLoader && !disableRates) {
            if (isRateBandSelected) {
                setEventMessage('')
                const faciData = JSON.parse(JSON.stringify(facilityData))
                let curFacTime = new Date(getConvertedDate(moment(new Date()).tz(faciData?.facility?.timezone ? faciData?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD HH:mm:ss')))
                faciData.valid_till = curFacTime
                faciData.parking_amount = '0.00'
                faciData.processing_fee = '0.00'
                faciData.tax_rate = '0.00'
                faciData.paid_amount = '0.00'
                faciData.payable_amount = '0.00'
                faciData.is_price_applicable = '0'
                faciData.discount_amount = '0'
                faciData.discount_hours = '0'
                if (facilityData?.facility?.facility_configuration?.is_overnight_hourly_enabled == '1' || facilityData?.facility_configuration?.is_overnight_hourly_enabled == '1') {
                    faciData.surcharge_fee = '0.00'
                }
                faciData.display_msg = ''
                setFacilityData(faciData)
                this.props.setIsRateBandSelected(false)
                this.setState({ eventsIndex: null })
                setIndexForCalc({
                    ...indexForCalc,
                    bandIndex: 0
                })
                setTotalHoursLength('0.00')
                // this.handleChange('events', null)
                // setRateBandData(EMPTY_ARRAY)
            } else {
                setEventMessage(data?.title)
                this.handleChange('events', data?.event_id)
                this.props.dispatch({ type: CONSTANTS.PROMO_MSGE_ENABLE })
                this.setState({ eventsIndex: i })
                this.props.setIsRateBandSelected(true)
                setIndexForCalc({
                    ...indexForCalc,
                    bandIndex: i + 1
                })
            }
            setIsRateOrEventShow(1)
        }
        // this.props.setselctedDateTime({...this.props.selctedDateTime, bandActive: false})
    }

    handleUpKey = (e, num, band = [], type = '') => {

        const { setIndexForCalc, indexForCalc } = this.props
        if (indexForCalc?.bandIndex >= 0 && indexForCalc?.bandIndex < band?.rateBands?.length - 2) {
            // this.setState({bandIndex: indexForCalc?.bandIndex + 1})
            setIndexForCalc({
                ...indexForCalc,
                bandIndex: indexForCalc?.bandIndex + 1
            })
        } else {
            // this.setState({bandIndex: indexForCalc?.bandIndex})
            setIndexForCalc({
                ...indexForCalc,
                bandIndex: indexForCalc?.bandIndex
            })
        }
        let add = num
        if (e[Object.keys(e)] == 31 && type == 'day') {
            add = 0
        }
        if (e[Object.keys(e)] == 23 && type == 'hour') {
            add = 0
        }
        if (e[Object.keys(e)] == 45 && type == 'minute') {
            add = 0
        }
        if (Object.keys(e)[0] == 'rateBands') {
            if (indexForCalc?.bandIndex >= 0 && indexForCalc?.bandIndex < band?.rateBands?.length) {
                this.handleChange(Object.keys(e)[0], band?.rateBands[indexForCalc?.bandIndex + 1])
            }
        } else {
            this.handleChange(Object.keys(e)[0], e[Object.keys(e)] + add)
        }

    }
    handleUpDownKey = (e, num, band = []) => {
        const { setIndexForCalc, indexForCalc } = this.props
        if (indexForCalc?.bandIndex > 0 && indexForCalc?.bandIndex <= band?.rateBands?.length - 2) {
            // this.setState({bandIndex: this.props.indexForCalc?.bandIndex - 1})
            setIndexForCalc({
                ...indexForCalc,
                bandIndex: indexForCalc?.bandIndex + 1
            })
        }

        let sub = num
        if (e[Object.keys(e)] == 0) {
            sub = 0
        }
        if (Object.keys(e)[0] == 'rateBands') {
            if (indexForCalc?.bandIndex >= 0 && indexForCalc?.bandIndex <= band?.rateBands?.length) {
                this.handleChange(Object.keys(e)[0], band?.rateBands[indexForCalc?.bandIndex])
            }
        } else {
            this.handleChange(Object.keys(e)[0], e[Object.keys(e)] - sub)
        }

    }

    /* Static Code for the Demo */
    handleDurationSelector = (e) => {
        const { handleTimeLength, priceBreakAPI, setResetPromo, setDurationSelector, handleBlur, openDateCalendar, facilityData, selctedDateTime, totalHoursLength, setselctedDateTime, partnerdetails } = this.props
        setResetPromo(true)
        if (selctedDateTime?.bandActive && (facilityData?.facility?.facility_configuration?.is_overnight_hourly_enabled == '1' || facilityData?.facility_configuration?.is_overnight_hourly_enabled == '1')) {
            openDateCalendar(true, false)
        }
        const { value } = e.target
        setDurationSelector(value)
        if (value == 0) {
            const e = { target: { 'name': ['day'], 'value': 0, key: 'isStatic' } }
            this.setState({ dayValueGroups: { day: 0 } })
            if (totalHoursLength && Number(totalHoursLength) > 0) {
                handleTimeLength(e)
                setselctedDateTime({ ...selctedDateTime, active: false, bandActive: false, price: 0, daysHrs: null })
            }
            if (!loggedInUserData()?.user?.id && isPermissionExist(sortPortalPermissionByKey(partnerdetails, 'Restricted Permissions'), 'Enable Name Fields - Transient')) {
                handleBlur({ target: { name: 'first_name' } }, true)
                handleBlur({ target: { name: 'last_name' } }, true)
            }
        } else {
            this.setState({ hourValueGroups: { hour: 0 }, minuteValueGroups: { minute: 0 }, })
            const hour = { target: { 'name': ['hour'], 'value': 0, key: 'isStatic' } }
            const minute = { target: { 'name': ['minute'], 'value': 0, key: 'isStatic' } }
            if (totalHoursLength && Number(totalHoursLength) > 0) {
                handleTimeLength(hour)
                handleTimeLength(minute)
                priceBreakAPI(false)
                setselctedDateTime({ ...selctedDateTime, active: false, bandActive: false, price: 0 })
            }
        }
    }
    /* Static Code for the Demo */

    hourselections = {
        hour: hoursData,
        //hour: [0,1,2,3]
    }
    minuteselections = {
        minute: minutesData,
        //hour: [0,1,2,3]
    }
    dayselections = {
        day: dayData,
        //hour: [0,1,2,3]
    }

    render() {
        const {
            dayValueGroups,
            // dayOptionGroups,
            hourValueGroups,
            // hourOptionGroups,
            // minuteOptionGroups,
            minuteValueGroups,
            rateBandsValues,
            eventsIndex,
            is_rate_display_with_events,
        } = this.state
        const { isMultiParking, isRateBand, rateBands, activeRateBand,
            recieptLoader, events, priceBandLoad,
            indexForCalc, partnerdetails, facilityData,
            durationSelector, hotel_type, openDateCalendar,
            eventMessage, extend_loader, fetchRateLoader, is_rate_or_event_show,
            oversizeLoader
            // rateBandData
        } = this.props
        // const user = window.location.toString().split('/')[3]

        return (
            <div className={`${(rateBands?.rateBands?.length > 4 || events?.length > 4 || (is_rate_display_with_events && (rateBands?.rateBands?.length + events?.length) > 4)) ? 'pe-2 overflow-y-auto ' : ''}${eventMessage ? '' : 'mb-2 '}p-0 m-0 position-relative mb-2`} style={{ maxHeight: '273px' }}>
                {/* Static Code for the Demo */}
                {((facilityData?.facility?.facility_configuration?.is_overnight_hourly_enabled == '1' || facilityData?.facility_configuration?.is_overnight_hourly_enabled == '1') && (!events || events?.length == 0)) ?
                    <div className="btn-group w-100 my-2 " role="group" aria-label="Small button group">
                        <input type="radio" disabled={(fetchRateLoader && durationSelector == 0)} className={durationSelector == 1 ? 'btn-check text-white' : 'text-primary btn-check'} name="btnradio" id="btnradio1" autoComplete="off" value="1" checked={durationSelector == 1 ? true : false} onChange={(e) => this.handleDurationSelector(e)} />
                        <label className={durationSelector == 1 ? 'btn btn-outline-primary text-white' : 'btn btn-outline-primary text-primary'} htmlFor="btnradio1">Overnight</label>
                        {(facilityData?.facility_configuration?.is_hourly_parking == '1' || facilityData?.facility?.facility_configuration?.is_hourly_parking == '1') || (facilityData?.facility_configuration?.is_minutes_parking == '1' || facilityData?.facility?.facility_configuration?.is_minutes_parking == '1') ? <>
                            <input type="radio" disabled={(fetchRateLoader && durationSelector == 0)} className={durationSelector == 0 ? 'btn-check text-white' : 'text-primary btn-check'} name="btnradio" id="btnradio2" autoComplete="off" value="0" checked={durationSelector == 0 ? true : false} onChange={(e) => this.handleDurationSelector(e)} />
                            <label className={durationSelector == 0 ? 'btn btn-outline-primary text-white' : 'btn btn-outline-primary text-primary'} htmlFor="btnradio2">Hourly</label>
                        </> : null}
                    </div>
                    : null}
                {/* Static Code for the Demo */}
                {/* {((priceBandLoad || customeLoaderForRateBand */}
                {((priceBandLoad
                ) && isRateBand && !oversizeLoader) ? <div className='d-flex justify-content-center start-50' style={{ top: '15px' }}>
                    <Circles
                        height="20"
                        width="20"
                        style={{ display: 'inline-block' }}
                        color="#26A8E0"
                        ariaLabel="circles-loading"
                        visible={true}
                    />
                </div> :
                    (events?.length > 0) ?
                        // <>{recieptLoader ? <div className='position-absolute h-100 w-100 d-flex justify-content-center align-items-center z-index-hige bg-grey border rounded opacity-75'><i className='fa fa-spinner fa-spin'></i></div> : null}<Row className='p-0 m-0 d-flex justify-content-center align-items-center'>
                        <>{recieptLoader ? null : null} <Row className='p-0 m-0 d-flex justify-content-center align-items-center'>
                            {events.map((event, index) =>
                                <div onClick={() => { this.cliclEvent(event, index) }}
                                    key={'event_' + index}
                                    className={`${(eventsIndex === index && this.props.isRateBandSelected && (is_rate_or_event_show == 1 && is_rate_display_with_events)) ? 'border-primary active-band' : (eventsIndex !== index && this.props.isRateBandSelected) ? 'd-none' : 'border-grey'} border border-2 rounded m-2 pb-1 cursor ${activeRateBand ? '' : 'opacity-50'}`} style={
                                        (partnerdetails?.brand_setting?.color && indexForCalc?.bandIndex && (indexForCalc?.bandIndex - 1 === index) && this.props.isRateBandSelected) ? { backgroundColor: partnerdetails?.brand_setting?.color, color: '#fff' } : {}
                                    }>
                                    {/* <div className={`${(rateBandData.length > index && rateBandData[index]?.category_id == '316') ? 'pb-0' : 'pb-1'} pt-1 d-flex justify-content-between`}> */}
                                    <div className='pt-1 d-flex justify-content-between'>
                                        {event.title} <span>{oversizeLoader ? <div className='d-inline-block align-middle mb-1 me-2'><Circles height="17" width="17" style={{ display: 'inline' }} color="#ffffff" ariaLabel="circles-loading" visible={true} /></div> : <>${Number(event?.driveup_event_rate).toFixed(2)}</>} {(eventsIndex === index && this.props.isRateBandSelected) ? <i className='fa fa-chevron-right'></i> : ''} </span>
                                    </div>
                                    {event?.start_time ? <div className='sub-label small'><small>Event start at:- {moment(event.start_time).format('hh:mm A')}</small></div> : ''}
                                    {/* This will be come in future {(rateBandData.length > index && rateBandData[index]?.category_id == '316') ? <div className='sub-label small text-muted'><small>{rateBandData[index]?.open_time_description} - {rateBandData[index]?.exit_time_details}</small></div> : ''} */}
                                </div>
                            )}

                            {(is_rate_display_with_events) ? <>
                                {recieptLoader ? null : null}
                                <Row className='p-0 m-0 d-flex justify-content-center align-items-center'>
                                    {rateBands?.rateBands?.length > 0 && rateBands.rateBands.map((rate, index) =>
                                        <div onClick={() => { this.cliclRateBand(rateBandsValues, rateBands, index, (indexForCalc?.bandIndex - 1)) }}
                                            key={'rate_' + index}
                                            className={`${(indexForCalc?.bandIndex && (indexForCalc?.bandIndex - 1 === index) && this.props.isRateBandSelected && (is_rate_or_event_show == 2 && is_rate_display_with_events)) ?
                                                'border-primary active-band' : (indexForCalc?.bandIndex || this.props?.selctedDateTime?.bandActive) ? 'd-none' : 'border-grey'} border border-2 rounded m-2 pb-2 pt-2 cursor ${activeRateBand ? '' : 'opacity-50'}`} style={
                                                    (partnerdetails?.brand_setting?.color && indexForCalc?.bandIndex && (indexForCalc?.bandIndex - 1 === index) && this.props.isRateBandSelected) ? { backgroundColor: partnerdetails?.brand_setting?.color, color: '#fff' } : {}
                                                }>
                                            <div className='pb-1 pt-1 d-flex justify-content-between'>
                                                {rate} <span>${Number(rateBands?.price[index]).toFixed(2)} {(indexForCalc?.bandIndex && (indexForCalc?.bandIndex - 1 === index) && this.props.isRateBandSelected) ? <i className='fa fa-chevron-right'></i> : ''} </span>
                                            </div>
                                        </div>
                                    )
                                    }
                                </Row>
                            </> : null}
                        </Row></> :
                        isRateBand ?
                            <>
                                {/* {recieptLoader ? <div className='position-absolute h-100 w-100 d-flex justify-content-center align-items-center z-index-hige bg-grey border rounded opacity-75'><i className='fa fa-spinner fa-spin'></i></div> : null} */}
                                {recieptLoader ? null : null}
                                <Row className='p-0 m-0 d-flex justify-content-center align-items-center'>
                                    {/* <div className='border border-2 rounded border-primary m-2 pb-3 pt-2'>
                            <Picker optionGroups={rateBands} valueGroups={rateBandsValues} onChange={this.handleChange} wheel='normal' className='text-black fw-bold w-100' />
                            <Row className='ms-1 text-end arrowContainer'>
                                <i className="fa fa-caret-up text-black " aria-hidden="true"
                                    onClick={() => { this.handleUpKey(rateBandsValues, 1, rateBands) }}
                                // onClick={(e) => this.handleUpDownKey(e, 'hour-up')}
                                ></i>
                                <i className="fa fa-caret-down text-black  " aria-hidden="true"
                                    // onClick={(e) => handleTimeLength(e, 'hour-down')}
                                    onClick={() => this.handleUpDownKey(rateBandsValues, 1, rateBands)}
                                ></i>
                            </Row>
                        </div> */}
                                    {rateBands?.rateBands?.length > 0 && rateBands.rateBands.map((rate, index) =>
                                        <div onClick={() => { this.cliclRateBand(rateBandsValues, rateBands, index, (indexForCalc?.bandIndex - 1)) }}
                                            key={'rate_' + index}
                                            className={`${(indexForCalc?.bandIndex && (indexForCalc?.bandIndex - 1 === index) && this.props.isRateBandSelected) ?
                                                'border-primary active-band' : (indexForCalc?.bandIndex || this.props?.selctedDateTime?.bandActive) ? 'd-none' : 'border-grey'} border border-2 rounded m-2 pb-2 pt-2 cursor ${activeRateBand ? '' : 'opacity-50'}`} style={
                                                    (partnerdetails?.brand_setting?.color && indexForCalc?.bandIndex && (indexForCalc?.bandIndex - 1 === index) && this.props.isRateBandSelected) ? { backgroundColor: partnerdetails?.brand_setting?.color, color: '#fff' } : {}
                                                }>
                                            {/* <div className={`${(rateBandData.length > index && rateBandData[index]?.category_id == '316') ? 'pb-0' : 'pb-1'} pt-1 d-flex justify-content-between`}> */}
                                            <div className='pb-1 pt-1 d-flex justify-content-between'>
                                                {rate} <span>{oversizeLoader ? <div className='d-inline-block align-middle mb-1 me-2'><Circles height="17" width="17" style={{ display: 'inline' }} color="#ffffff" ariaLabel="circles-loading" visible={true} /></div> : <>${Number(rateBands?.price[index]).toFixed(2)}</>} {(indexForCalc?.bandIndex && (indexForCalc?.bandIndex - 1 === index) && this.props.isRateBandSelected) ? <i className='fa fa-chevron-right'></i> : ''} </span>
                                            </div>
                                            {/* This will be come in future {(rateBandData.length > index && rateBandData[index]?.category_id == '316') ? <div className='sub-label small text-muted'><small>{rateBandData[index]?.open_time_description} - {rateBandData[index]?.exit_time_details}</small></div> : ''} */}
                                        </div>
                                    )
                                    }
                                </Row>
                            </> :
                            /* Static Code for the Demo */
                            (facilityData?.facility?.facility_configuration?.is_overnight_hourly_enabled == '1' || facilityData?.facility_configuration?.is_overnight_hourly_enabled == '1') ?
                                <Row className='p-0 d-flex justify-content-center align-items-center'>
                                    {(isMultiParking && durationSelector == 1 && hotel_type != '1') ?
                                        <div className='border border-2 rounded border-primary m-2 pickerWidth pb-3 '>
                                            <p className='reactMobilityPickerLabel text-black fw-semibold p-0 m-0'>Days</p>
                                            {/* <Picker optionGroups={dayOptionGroups} valueGroups={dayValueGroups} onChange={this.handleChange} wheel='normal' /> */}
                                            <Picker wheel="natural"
                                                value={dayValueGroups}
                                                // option={dayValueGroups}
                                                height={42}
                                                onChange={(e) => {
                                                    this.handleChange(Object.keys(e)[0], Object.values(e)[0])
                                                }}
                                                className='mobi-scroll-border-0'
                                            >
                                                {Object.keys(this.dayselections).map(name => (
                                                    <Picker.Column key={name} name={name}>
                                                        {this.dayselections[name].map(option => (
                                                            <Picker.Item key={option} value={option}>
                                                                {option}
                                                            </Picker.Item>
                                                        ))}
                                                    </Picker.Column>
                                                ))}

                                            </Picker>
                                            <Row className='ms-1 text-end arrowContainer'>

                                                <i className="fa fa-caret-up text-black " aria-hidden="false"
                                                    onClick={() => { this.handleUpKey(dayValueGroups, 1, '', 'day') }}
                                                // onClick={(e) => this.handleUpDownKey(e, 'hour-up')}
                                                ></i>
                                                <i className="fa fa-caret-down text-black  " aria-hidden="true"
                                                    // onClick={(e) => handleTimeLength(e, 'hour-down')}
                                                    onClick={() => this.handleUpDownKey(dayValueGroups, 1)}
                                                ></i>
                                            </Row>
                                        </div>
                                        : (hotel_type == '1' && durationSelector == 1) ? <div className='px-1'>
                                            <div className='p-2 m-0 d-flex justify-content-center align-items-center row'>
                                                <div className={`${this.props.selctedDateTime?.bandActive ? '' : this.props.isRateBandSelected ? 'd-none' : ''} border border-2 rounded m-2 pb-2 pt-2`} onClick={() => openDateCalendar(true, true)} style={
                                                    (partnerdetails?.brand_setting?.color && this.props.selctedDateTime?.bandActive) ? { backgroundColor: partnerdetails?.brand_setting?.color, color: '#fff' } : {}
                                                }>
                                                    <div className='pb-1 pt-1 d-flex justify-content-between align-items-center'>
                                                        <div className='lh-sm'>{(this.props.selctedDateTime?.active && !this.props.isRateBandSelected) ? this.props.selctedDateTime?.daysHrs : 'Departure Date'}<div className={`sub-label small ${this.props.selctedDateTime?.bandActive ? '' : 'text-muted'}`}></div></div>
                                                        <span>{(fetchRateLoader || (extend_loader && this.props.selctedDateTime?.active)) ? <Circles
                                                            height="24"
                                                            width="24"
                                                            style={{ display: 'inline-block' }}
                                                            color="#FFF"
                                                            ariaLabel="circles-loading"
                                                            visible={true}
                                                        /> : (this.props.selctedDateTime?.active && !this.props.isRateBandSelected && !fetchRateLoader) ? '$' + Number(this.props.selctedDateTime?.price).toFixed(2) : '--'}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> : null}

                                    {durationSelector == 0 && (facilityData?.facility?.facility_configuration?.is_hourly_parking == 1 || facilityData?.facility_configuration?.is_hourly_parking == 1) ? <div className='border border-2 rounded border-primary m-2 pickerWidth pb-3'>
                                        <p className='reactMobilityPickerLabel text-black fw-semibold p-0 m-0'>Hours</p>
                                        {/* <Picker optionGroups={hourOptionGroups} valueGroups={hourValueGroups} onChange={this.handleChange} wheel='normal' className='text-black fw-bold' /> */}
                                        <Picker wheel="natural"
                                            value={hourValueGroups}
                                            // option={hourValueGroups}
                                            height={42}
                                            onChange={(e) => {
                                                this.handleChange(Object.keys(e)[0], Object.values(e)[0])
                                            }}
                                            className='mobi-scroll-border-0'
                                        >
                                            {Object.keys(this.hourselections).map(name => (
                                                <Picker.Column key={name} name={name}>
                                                    {this.hourselections[name].map(option => (
                                                        <Picker.Item key={option} value={option}>
                                                            {option}
                                                        </Picker.Item>
                                                    ))}
                                                </Picker.Column>
                                            ))}

                                        </Picker>
                                        <Row className='ms-1 text-end arrowContainer'>
                                            <i className="fa fa-caret-up text-black " aria-hidden="true"
                                                onClick={() => { this.handleUpKey(hourValueGroups, 1, '', 'hour') }}
                                            // onClick={(e) => this.handleUpDownKey(e, 'hour-up')}
                                            ></i>
                                            <i className="fa fa-caret-down text-black  " aria-hidden="true"
                                                // onClick={(e) => handleTimeLength(e, 'hour-down')}
                                                onClick={() => this.handleUpDownKey(hourValueGroups, 1)}
                                            ></i>
                                        </Row>
                                    </div> : null}
                                    {durationSelector == 0 && (facilityData?.facility?.facility_configuration?.is_minutes_parking == 1 || facilityData?.facility_configuration?.is_minutes_parking == 1) ? <div className='border border-2 rounded border-primary m-2 pickerWidth pb-3'>
                                        <p className='reactMobilityPickerLabel text-black fw-semibold p-0 m-0'>Minutes</p>
                                        {/* <Picker optionGroups={minuteOptionGroups} valueGroups={minuteValueGroups} onChange={this.handleChange} wheel='normal' /> */}
                                        <Picker wheel="natural"
                                            value={minuteValueGroups}
                                            // option={minuteValueGroups}
                                            height={42}
                                            onChange={(e) => {
                                                this.handleChange(Object.keys(e)[0], Object.values(e)[0])
                                            }}
                                            className='mobi-scroll-border-0'
                                        >
                                            {Object.keys(this.minuteselections).map(name => (
                                                <Picker.Column key={name} name={name}>
                                                    {this.minuteselections[name].map(option => (
                                                        <Picker.Item key={option} value={option}>
                                                            {option}
                                                        </Picker.Item>
                                                    ))}
                                                </Picker.Column>
                                            ))}

                                        </Picker>
                                        <Row className='ms-1 text-end arrowContainer'>
                                            <i className="fa fa-caret-up text-black " aria-hidden="true"
                                                onClick={() => { this.handleUpKey(minuteValueGroups, 15, '', 'minute') }}>

                                            </i>
                                            <i className="fa fa-caret-down text-black  " aria-hidden="true"
                                                onClick={() => this.handleUpDownKey(minuteValueGroups, 15)}></i>
                                        </Row>
                                    </div> : null}
                                </Row> :
                                <Row className='p-0 d-flex justify-content-center align-items-center'>
                                    {(isMultiParking) &&
                                        <div className='border border-2 rounded border-primary m-2 pickerWidth pb-3 '>
                                            <p className='reactMobilityPickerLabel text-black fw-semibold p-0 m-0'>Days</p>
                                            {/* <Picker optionGroups={dayOptionGroups} valueGroups={dayValueGroups} onChange={this.handleChange} wheel='normal' /> */}
                                            <Picker wheel="natural"
                                                value={dayValueGroups}
                                                // option={dayValueGroups}
                                                height={42}
                                                onChange={(e) => {
                                                    this.handleChange(Object.keys(e)[0], Object.values(e)[0])
                                                }}
                                                className='mobi-scroll-border-0'
                                            >
                                                {Object.keys(this.dayselections).map(name => (
                                                    <Picker.Column key={name} name={name}>
                                                        {this.dayselections[name].map(option => (
                                                            <Picker.Item key={option} value={option}>
                                                                {option}
                                                            </Picker.Item>
                                                        ))}
                                                    </Picker.Column>
                                                ))}

                                            </Picker>
                                            <Row className='ms-1 text-end arrowContainer'>

                                                <i className="fa fa-caret-up text-black " aria-hidden="false"
                                                    onClick={() => { this.handleUpKey(dayValueGroups, 1, '', 'day') }}
                                                // onClick={(e) => this.handleUpDownKey(e, 'hour-up')}
                                                ></i>
                                                <i className="fa fa-caret-down text-black  " aria-hidden="true"
                                                    // onClick={(e) => handleTimeLength(e, 'hour-down')}
                                                    onClick={() => this.handleUpDownKey(dayValueGroups, 1)}
                                                ></i>
                                            </Row>
                                        </div>
                                    }

                                    {(facilityData?.facility?.facility_configuration?.is_hourly_parking == 1 || facilityData?.facility_configuration?.is_hourly_parking == 1) ? <div className='border border-2 rounded border-primary m-2 pickerWidth pb-3'>
                                        <p className='reactMobilityPickerLabel text-black fw-semibold p-0 m-0'>Hours</p>
                                        {/* <Picker optionGroups={hourOptionGroups} valueGroups={hourValueGroups} onChange={this.handleChange} wheel='normal' className='text-black fw-bold' /> */}
                                        <Picker wheel="natural"
                                            value={hourValueGroups}
                                            // option={hourValueGroups}
                                            height={42}
                                            onChange={(e) => {
                                                this.handleChange(Object.keys(e)[0], Object.values(e)[0])
                                            }}
                                            className='mobi-scroll-border-0'
                                        >
                                            {Object.keys(this.hourselections).map(name => (
                                                <Picker.Column key={name} name={name}>
                                                    {this.hourselections[name].map(option => (
                                                        <Picker.Item key={option} value={option}>
                                                            {option}
                                                        </Picker.Item>
                                                    ))}
                                                </Picker.Column>
                                            ))}

                                        </Picker>
                                        <Row className='ms-1 text-end arrowContainer'>
                                            <i className="fa fa-caret-up text-black " aria-hidden="true"
                                                onClick={() => { this.handleUpKey(hourValueGroups, 1, '', 'hour') }}
                                            // onClick={(e) => this.handleUpDownKey(e, 'hour-up')}
                                            ></i>
                                            <i className="fa fa-caret-down text-black  " aria-hidden="true"
                                                // onClick={(e) => handleTimeLength(e, 'hour-down')}
                                                onClick={() => this.handleUpDownKey(hourValueGroups, 1)}
                                            ></i>
                                        </Row>
                                    </div> : null}
                                    
                                    {(facilityData?.facility?.facility_configuration?.is_minutes_parking == 1 || facilityData?.facility_configuration?.is_minutes_parking == 1) ? <div className='border border-2 rounded border-primary m-2 pickerWidth pb-3'>
                                        <p className='reactMobilityPickerLabel text-black fw-semibold p-0 m-0'>Minutes</p>
                                        {/* <Picker optionGroups={minuteOptionGroups} valueGroups={minuteValueGroups} onChange={this.handleChange} wheel='normal' /> */}
                                        <Picker wheel="natural"
                                            value={minuteValueGroups}
                                            // option={minuteValueGroups}
                                            height={42}
                                            onChange={(e) => {
                                                this.handleChange(Object.keys(e)[0], Object.values(e)[0])
                                            }}
                                            className='mobi-scroll-border-0'
                                        >
                                            {Object.keys(this.minuteselections).map(name => (
                                                <Picker.Column key={name} name={name}>
                                                    {this.minuteselections[name].map(option => (
                                                        <Picker.Item key={option} value={option}>
                                                            {option}
                                                        </Picker.Item>
                                                    ))}
                                                </Picker.Column>
                                            ))}

                                        </Picker>
                                        <Row className='ms-1 text-end arrowContainer'>
                                            <i className="fa fa-caret-up text-black " aria-hidden="true"
                                                onClick={() => { this.handleUpKey(minuteValueGroups, 15, '', 'minute') }}>

                                            </i>
                                            <i className="fa fa-caret-down text-black  " aria-hidden="true"
                                                onClick={() => this.handleUpDownKey(minuteValueGroups, 15)}></i>
                                        </Row>
                                    </div> : null}
                                </Row>}
                {/* Static Code for the Demo */}
            </div>
        )
    }
}

ReactMobiltySpinner.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    extend_loader: PropTypes.bool,
    isMultiParking: PropTypes.bool,
    handleTimeLength: PropTypes.func,
    currDays: PropTypes.number,
    currHour: PropTypes.number,
    currMin: PropTypes.number,
    isRateBand: PropTypes.bool,
    rateBands: PropTypes.array,
    isRateBandSelected: PropTypes.bool,
    setIsRateBandSelected: PropTypes.func,
    setselctedDateTime: PropTypes.func,
    selctedDateTime: PropTypes.object,
    setRateBandData: PropTypes.func,
    events: PropTypes.array,
    activeRateBand: PropTypes.bool,
    recieptLoader: PropTypes.bool,
    priceBandLoad: PropTypes.bool,
    setFacilityData: PropTypes.func,
    setSelectedEv: PropTypes.func,
    facilityData: PropTypes.object,
    indexForCalc: PropTypes.object,
    setIndexForCalc: PropTypes.func,
    setSeletedRateBand: PropTypes.func,
    setTotalHoursLength: PropTypes.func,
    priceBreakAPI: PropTypes.func,
    setTimeDuration: PropTypes.func,
    setIsDisplayRateBand: PropTypes.func,
    setRateBandId: PropTypes.func,
    page: PropTypes.string,
    setCustomeLoaderForRateBand: PropTypes.func,
    customeLoaderForRateBand: PropTypes.bool,
    partnerdetails: PropTypes.object,
    pageOnLoad: PropTypes.bool,
    setIsRateChangedWithPromo: PropTypes.func,
    setIsPriceZero: PropTypes.func,
    setResetPromo: PropTypes.func,
    durationSelector: PropTypes.number,
    setDurationSelector: PropTypes.func,
    handleBlur: PropTypes.func,
    hotel_type: PropTypes.number,
    openDateCalendar: PropTypes.func,
    currentSelVehicle: PropTypes.object,
    setEventMessage: PropTypes.func,
    eventMessage: PropTypes.func,
    totalHoursLength: PropTypes.string,
    screen: PropTypes.string,
    fetchRateLoader: PropTypes.bool,
    is_rate_or_event_show: PropTypes.number,
    setIsRateOrEventShow: PropTypes.func,
    resetBand: PropTypes.number,
    curRateBandRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    oversizeLoader: PropTypes.bool,
    disableRates: PropTypes.bool,
    ticketDetails: PropTypes.object,
    rateBandData: PropTypes.object,
    dataOnLoad: PropTypes.object,
}

ReactMobiltySpinner.defaulProps = {
    dispatch: noop,
    loader: true,
    extend_loader: false,
    isMultiParking: false,
    handleTimeLength: noop,
    currDays: 0,
    currHour: 0,
    currMin: 0,
    isRateBand: false,
    rateBands: EMPTY_ARRAY,
    isRateBandSelected: true,
    setIsRateBandSelected: noop,
    setselctedDateTime: noop,
    selctedDateTime: EMPTY_OBJECT,
    setRateBandData: noop,
    events: EMPTY_ARRAY,
    activeRateBand: true,
    recieptLoader: false,
    priceBandLoad: false,
    setFacilityData: noop,
    setSelectedEv: noop,
    facilityData: EMPTY_OBJECT,
    indexForCalc: EMPTY_OBJECT,
    setIndexForCalc: noop,
    setSeletedRateBand: noop,
    setTotalHoursLength: noop,
    priceBreakAPI: noop,
    setTimeDuration: noop,
    setIsDisplayRateBand: noop,
    setRateBandId: noop,
    page: '',
    setCustomeLoaderForRateBand: noop,
    customeLoaderForRateBand: false,
    partnerdetails: EMPTY_OBJECT,
    pageOnLoad: false,
    setIsRateChangedWithPromo: noop,
    setIsPriceZero: noop,
    setResetPromo: noop,
    durationSelector: 1,
    setDurationSelector: noop,
    handleBlur: noop,
    hotel_type: '0',
    openDateCalendar: noop,
    currentSelVehicle: EMPTY_OBJECT,
    setEventMessage: noop,
    eventMessage: noop,
    totalHoursLength: '',
    screen: '',
    fetchRateLoader: false,
    is_rate_or_event_show: 0,
    setIsRateOrEventShow: noop,
    resetBand: 0,
    curRateBandRef: null,
    oversizeLoader: false,
    disableRates: false,
    ticketDetails: EMPTY_OBJECT,
    rateBandData: EMPTY_OBJECT,
    dataOnLoad: EMPTY_OBJECT,
}

function mapStateToProps({ transientReducer, PaymentReducer, VehilceReducer, ReceiptsReducer }) {
    const { data } = VehilceReducer

    return {
        loader: transientReducer?.loader,
        fetchRateLoader: transientReducer?.fetchRateLoader,
        extend_loader: transientReducer?.extend_loader,
        isFetching: transientReducer?.isFetching,
        cards: PaymentReducer?.data?.data,
        vehicleDataList: data?.data,
        activeRateBand: transientReducer?.activeRateBandsClick,
        recieptLoader: ReceiptsReducer.loader,
        priceBandLoad: transientReducer.priceBandAPI
    }
}

export default connect(mapStateToProps)(ReactMobiltySpinner)